import script from "./ErrorScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&setup=true&lang=js"

import "./ErrorScreen.vue?vue&type=style&index=0&id=36b54c1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b54c1e"]])

export default __exports__